import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * Scroll to a section id on the home page (or navigate home then scroll).
 */
export default function useSectionNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToSection = useCallback(
    (sectionId) => {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(() => {
          document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
        }, 100);
      } else {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }
    },
    [location.pathname, navigate]
  );

  return goToSection;
}
